import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { SalesComponent } from './sales/sales.component';
import { NotFoundComponent } from './miscellaneous/not-found/not-found.component';
import { BartendersComponent } from './bartenders/bartenders.component';
import { UsersComponent } from './users/users.component';
import { EventdetailsComponent } from './eventdetails/eventdetails.component';
import { GeneratorComponent } from './generator/generator.component';
import { MarketingComponent } from './marketing/marketing.component';
import { ManagersComponent } from './managers/managers.component';
import { PricelistComponent } from './pricelist/pricelist/pricelist.component';
import { TokengeneratorComponent } from './tokengenerator/tokengenerator.component';
import { SalesdetailComponent } from './salesdetail/salesdetail.component';
import { InvoicerequestsComponent } from './invoicerequests/invoicerequests.component';
import { HorecaTouchComponent } from './horeca-touch/horeca-touch.component';


const routes: Routes = [{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: ':eventId/sales',
      component: SalesComponent,
    },
    {
      path: ':eventId/salesdetail',
      component: SalesdetailComponent,
    },
    {
      path: ':eventId/bartenders',
      component: BartendersComponent,
    },
    {
      path: ':eventId/managers',
      component: ManagersComponent,
    },
    {
      path: ':eventId/tokengenerators',
      component: TokengeneratorComponent,
    },
    {
      path: ':eventId/users',
      component: UsersComponent,
    },
    {
      path: ':eventId/marketing',
      component: MarketingComponent,
    },
    {
      path: ':eventId/eventdetails',
      component: EventdetailsComponent,
    },
    {
      path: ':eventId/pricelist',
      component: PricelistComponent,
    },
    {
      path: ':eventId/invoicerequests',
      component: InvoicerequestsComponent,
    },
    {
      path: ':eventId/generator',
      component: GeneratorComponent,
    },
    {
      path: ':eventId/horeca-touch',
      component: HorecaTouchComponent
    },
    {
      path: ':eventId',
      redirectTo: ':eventId/sales',
      pathMatch: 'full',
    },
    {
      path: '**',
      component: NotFoundComponent,
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
